

















































import Vue from 'vue'
import {mapActions, mapGetters} from 'vuex'
import GoogleSignup from '@/components/all/GoogleSignup.vue'
import FacebookSignup from '@/components/all/FacebookSignup.vue'
import BodyInformativa from '@/components/report/modals/BodyInformativaPrivacy.vue'

export default Vue.extend({
    components: {
        GoogleSignup,
        FacebookSignup, 
        BodyInformativa
    },
    data: () => ({
        logingin: true,
        showInformativa: false,
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        accettazione_privacy: false,
        messaggioWarningVisibile: false
    }),
    methods: {
        ...mapActions('modal', ['showModal']),
        login() {
            this.$store.dispatch('auth/login', {
                username: this.email,
                password: this.password
            })
        },
        hideWarning() {
            this.messaggioWarningVisibile = false
        },
        registration() {
            if (!this.accettazione_privacy) {
                this.messaggioWarningVisibile = true
            } else
                this.$store.dispatch('auth/registration', {
                    first_name: this.first_name,
                    last_name: this.last_name,
                    username: this.email,
                    email: this.email,
                    password1: this.password,
                    password2: this.password,
                })
        },
        toRegistration() {
            this.logingin = !this.logingin
        },
        showInformativaPrivacy () {
            this.showInformativa = true
        },
        colseInformativa () {
            this.showInformativa = false
        }
    },
    watch: {
        isAuthenticated: function(newValue) {
            if (newValue)
                setTimeout(() => {
                        this.showModal(null)
                    }, 1000)
        }
    },
    computed: {
        loginSuccessful: {
            get(): any {
                return this.$store.state.auth.loginSuccessful
            },
            set(value: any) {
                this.SET_LOGIN_SUCCESSFUL(value)
            }
        },
        ...mapGetters('auth', ['isAuthenticated'])
    }
})
